module.exports = __webpack_public_path__ + "img/c02_unitslinger_Normal_ua.351eb44e.webp";